window.i18n_it = {
  "general": {
    "accessibility": {
      "skip_to_content": "Vai direttamente ai contenuti",
      "close_modal": "Chiudi",
      "link_messages": {
        "new_window": "Apre in una nuova finestra.",
        "external": "Apre un sito esterno.",
        "new_window_and_external": "Apre un sito esterno in una nuova finestra."
      },
      "refresh_page": "Scegliendo una selezione si ottiene un aggiornamento completo della pagina.",
      "selection_help": "Premi la barra spaziatrice e i tasti freccia per effettuare una selezione.",
      "unit_price_separator": "per",
      "error": "Errore"
    },
    "meta": {
      "tags": "Tagged \"{{ tags }}\"",
      "page": "Pagina {{ page }}"
    },
    "404": {
      "title": "404 Pagina non trovata",
      "subtext": "La pagina che hai richiesto non esiste.",
      "link": "Continua lo shopping"
    },
    "pagination": {
      "previous": "Pagina precedente",
      "next": "Pagina successiva",
      "current_page": "Pagina {{ current }} di {{ total }}"
    },
    "password_page": {
      "opening_soon": "Prossima apertura",
      "login_form_heading": "Accedi al negozio usando la password",
      "login_form_password_label": "Password",
      "login_form_password_placeholder": "La tua password",
      "login_form_submit": "Accedi",
      "signup_form_email_label": "Email",
      "signup_form_success": "Ti invieremo un'email appena prima di aprire!",
      "admin_link_html": "Sei il proprietario del negozio? <a href=\"/admin\" class=\"text-link\">Accedi qui</a>",
      "password_link": "Accedi usando la password"
    },
    "social": {
      "share_on_facebook": "Condividi",
      "share_on_twitter": "Tweet",
      "share_on_pinterest": "Pin",
      "alt_text": {
        "share_on_facebook": "Condividi su Facebook",
        "share_on_twitter": "Twitta su Twitter",
        "share_on_pinterest": "Pinna su Pinterest"
      }
    },
    "search": {
      "empty_search_message": "Il campo di ricerca non può essere vuoto",
      "title": "Cerca nel nostro sito",
      "placeholder": "Cerca",
      "submit": "Invia",
      "close": "Chiudi ricerca",
      "heading": {
        "one": "Risultato della ricerca",
        "other": "Risultati della ricerca"
      },
      "search_for": "Cerca",
      "loading": "Caricamento",
      "clear_search_term": "Cancella termine ricerca",
      "number_of_results": "{{ result_number }} di {{ results_count }}",
      "products": "Prodotti",
      "number_of_results_found": "{{ results_count }} risultati trovati",
      "one_result_found": "1 risultato trovato",
      "no_results": "Controlla l'ortografia o prova una parola diversa.",
      "results_with_count": {
        "one": "{{ count }} risultato per “{{ terms }}”",
        "other": "{{ count }} risultati per “{{ terms }}”"
      }
    },
    "newsletter_form": {
      "newsletter_email": "Iscriviti alla nostra mailing list",
      "email_placeholder": "Indirizzo email",
      "confirmation": "Grazie per l'iscrizione!",
      "submit": "Iscriviti"
    },
    "filters": {
      "show_more": "Mostra di più",
      "show_less": "Mostra di meno"
    },
    "payment": {
      "method": "Metodi di pagamento"
    },
    "currency": {
      "dropdown_label": "Valuta"
    },
    "language": {
      "dropdown_label": "Lingua"
    }
  },
  "sections": {
    "slideshow": {
      "next_slide": "Slide successiva",
      "previous_slide": "Slide Precedente",
      "pause_slideshow": "Metti in pausa",
      "rotate_slideshow": "Avvia slideshow",
      "load_slide": "Carica slide {{ slide_number }}",
      "navigation_instructions": "Usa le frecce sinistra/destra per navigare nella presentazione o scorri a sinistra/destra se stai utilizzando un dispositivo mobile"
    },
    "featured_product": {
      "title": "Prodotto presentato",
      "gallery_thumbnail_alt": "Carica l'immagine nel visualizzatore di Gallery, {{ imageAlt }}",
      "video_thumbnail_alt": "Carica e avvia il video nel visualizzatore di galleria, {{ imageAlt }}",
      "model_thumbnail_alt": "Carica il modello 3D nel visualizzatore di Gallery, {{ imageAlt }}"
    },
    "map": {
      "address_error": "Errore durante la ricerca dell'indirizzo",
      "address_no_results": "La ricerca non ha prodotto alcun risultato per quell’indirizzo",
      "address_query_limit_html": "Hai superato il limite di utilizzo dell'API di Google. Considera l’aggiornamento a un <a href=\"https://developers.google.com/maps/premium/usage-limits\">Piano Premium</a>.",
      "auth_error_html": "Si è verificato un problema di autenticazione con il tuo account di Google Maps.",
      "section_heading": "Posizione"
    },
    "video": {
      "play": "Riproduci il video {{ video_title }}",
      "pause": "Metti in pausa il video {{ video_title }}",
      "resume": "Riprendi il video {{ video_title }}",
      "close": "Chiudi il video {{ video_title }}"
    },
    "header": {
      "announcement_bar_label": "Annuncio"
    }
  },
  "blogs": {
    "article": {
      "view_all": "Visualizza tutto",
      "view_all_blogs": "Visualizza tutti gli articoli",
      "all_topics": "Tutti gli argomenti",
      "by_author": "di {{ author }}",
      "posted_in": "Pubblicato in",
      "read_more": "Leggi di più",
      "read_more_title": "Leggi di più: {{ title }}",
      "back_to_blog": "Torna a {{ title }}",
      "tags": "Tag",
      "article_with_count": {
        "one": "{{ count }} articolo",
        "other": "{{ count }} articoli"
      }
    },
    "comments": {
      "title": "Lascia un commento",
      "name": "Nome",
      "email": "Email",
      "message": "Messaggio",
      "post": "Pubblica commento",
      "moderated": "Si prega di notare che i commenti sono soggetti ad approvazione prima di essere pubblicati",
      "success_moderated": "Il tuo commento è stato pubblicato. Lo pubblicheremo fra poco, il nostro blog è soggetto a moderazione.",
      "success": "Il tuo commento è stato pubblicato! Grazie!",
      "unapproved": "L'indirizzo email fornito non è approvato per la pubblicazione di commenti.",
      "comments_with_count": {
        "one": "{{ count }} commento",
        "other": "{{ count }} commenti"
      }
    }
  },
  "cart": {
    "general": {
      "title": "Il tuo carrello",
      "note": "Aggiungi una nota al tuo ordine",
      "removed_item_html": "<span class=\"cart__removed-product-details\">({{ quantity }}) {{ link }}</span> sono stati rimossi dal carrello.",
      "remove": "Rimuovi",
      "subtotal": "Subtotale",
      "savings": "Stai risparmiando",
      "taxes_and_shipping_at_checkout": "Imposte e spese di spedizione calcolate al momento del pagamento",
      "taxes_and_shipping_policy_at_checkout_html": "Imposte e <a href=\"{{ link }}\">spese di spedizione</a> calcolate al momento del pagamento",
      "taxes_included_but_shipping_at_checkout": "Imposte incluse e spese di spedizione calcolate al momento del pagamento",
      "taxes_included_and_shipping_policy_html": "Imposte incluse. <a href=\"{{ link }}\">Spedizione</a> calcolata al momento del pagamento.",
      "update": "Aggiornamento",
      "checkout": "Check-out",
      "empty": "Il tuo carrello è attualmente vuoto.",
      "cookies_required": "Abilita i cookie per utilizzare il carrello",
      "continue_shopping": "Continua lo shopping",
      "cart_error": "Si è verificato un errore durante l'aggiornamento del carrello. Riprova più tardi."
    },
    "label": {
      "discounted_total": "Totale scontato",
      "product": "Prodotto",
      "price": "Prezzo",
      "price_column": "Vedi la colonna Prezzo per i dettagli dello sconto.",
      "product_details": "Dettagli prodotto",
      "quantity": "Quantità",
      "qty": "Quantità",
      "regular_total": "Totale di listino",
      "remove": "Rimuovi {{ product }}",
      "total": "Totale",
      "update": "Aggiornamento"
    },
    "popup": {
      "added_to_cart": "Appena aggiunto al carrello",
      "cart_count": {
        "one": "{{ count }} articolo",
        "other": "{{ count }} articoli"
      },
      "product_details": "Dettagli prodotto",
      "quantity": "Quantità",
      "quantity_label": "Quantità: {{ quantity_count }}"
    }
  },
  "collections": {
    "general": {
      "view_all": "Visualizza tutto",
      "view_all_label": "Visualizza tutti i prodotti della collezione {{ collection_name }}",
      "no_matches": "Spiacenti, non ci sono prodotti in questa collezione",
      "items_with_count": {
        "one": "{{ count }} prodotto",
        "other": "{{ count }} prodotti"
      },
      "collection_label": "Collezione"
    },
    "catalog": {
      "title": "Catalogo"
    },
    "sorting": {
      "title": "Ordina per"
    },
    "filters": {
      "title_tags": "Filtra per",
      "all_tags": "Tutte i prodotti"
    }
  },
  "contact": {
    "form": {
      "name": "Nome",
      "email": "Email",
      "phone": "Numero di telefono",
      "message": "Messaggio",
      "submit": "Invia",
      "post_success": "Grazie per averci contattato. Risponderemo al più presto possibile.",
      "error_heading": "Si prega di regolare il seguente:"
    }
  },
  "customer": {
    "account": {
      "title": "Il mio account",
      "details": "Dettagli account",
      "view_addresses": "Visualizza indirizzi",
      "return": "Ritorna ai dettagli dell'account"
    },
    "activate_account": {
      "title": "Attiva il tuo account",
      "subtext": "Crea una password per attivare il tuo account.",
      "password": "Password",
      "password_confirm": "Conferma Password",
      "submit": "Attiva il tuo account",
      "cancel": "Rifiuta invito"
    },
    "addresses": {
      "title": "I tuoi indirizzi",
      "default": "Predefinito",
      "add_new": "Aggiungi un nuovo indirizzo",
      "edit_address": "Modifica indirizzo",
      "first_name": "Nome",
      "last_name": "Cognome",
      "company": "Azienda",
      "address1": "Indirizzo",
      "address2": "Interno, scala, ecc.",
      "city": "Città",
      "country": "Paese/Regione",
      "province": "Provincia",
      "zip": "CAP",
      "phone": "Numero di telefono",
      "set_default": "Imposta come indirizzo predefinito",
      "add": "Aggiungi indirizzo",
      "update": "Aggiorna indirizzo",
      "cancel": "Annulla",
      "edit": "Modifica",
      "delete": "Elimina",
      "delete_confirm": "Sei sicuro di voler eliminare questo indirizzo?"
    },
    "login": {
      "title": "Accesso",
      "email": "Email",
      "password": "Password",
      "forgot_password": "Hai dimenticato la password?",
      "sign_in": "Accedi",
      "guest_title": "Continua senza registrarti",
      "guest_continue": "Continua"
    },
    "orders": {
      "title": "Cronologia degli ordini",
      "order_number": "Ordine",
      "order_number_link": "Numero ordine {{ number }}",
      "date": "Data",
      "payment_status": "Stato del pagamento",
      "fulfillment_status": "Stato di evasione ordine",
      "total": "Totale",
      "none": "Non hai ancora effettuato ordini."
    },
    "order": {
      "title": "Ordine {{ name }}",
      "date_html": "Piazzato il {{ date }}",
      "cancelled_html": "Ordine annullato il {{ date }}",
      "cancelled_reason": "Motivo: {{ reason }}",
      "billing_address": "Indirizzo di fatturazione",
      "payment_status": "Stato del pagamento",
      "shipping_address": "Indirizzo Spedizione",
      "fulfillment_status": "Stato di evasione ordine",
      "discount": "Sconto",
      "shipping": "Spedizione",
      "tax": "Imposta",
      "product": "Prodotto",
      "sku": "SKU",
      "price": "Prezzo",
      "quantity": "Quantità",
      "total": "Totale",
      "fulfilled_at_html": "Evaso il {{ date }}",
      "subtotal": "Subtotale",
      "track_shipment": "Controlla lo status della spedizione"
    },
    "recover_password": {
      "title": "Reimposta la tua password",
      "email": "Email",
      "submit": "Invia",
      "cancel": "Annulla",
      "subtext": "Riceverai un'email per reimpostare la tua password.",
      "success": "Ti abbiamo inviato un'email con un link per aggiornare la tua password."
    },
    "reset_password": {
      "title": "Reimposta la tua password",
      "subtext": "Inserisci una nuova password per {{ email }}",
      "password": "Password",
      "password_confirm": "Conferma Password",
      "submit": "Reimposta la password"
    },
    "register": {
      "title": "Crea account",
      "first_name": "Nome",
      "last_name": "Cognome",
      "email": "Email",
      "password": "Password",
      "submit": "Crea"
    }
  },
  "homepage": {
    "general": {
      "title": "Homepage"
    },
    "onboarding": {
      "product_title": "Nome del tuo prodotto",
      "product_description": "Quest’area è per descrivere i dettagli del tuo prodotto. Qui puoi descrivere l'aspetto, il look e lo stile del prodotto ai tuoi clienti. Aggiungi dettagli sul colore, sui materiali utilizzati, sulle misure e su dove è stato creato.",
      "collection_title": "Nome della tua collezione",
      "blog_title": "Titolo del tuo post",
      "blog_excerpt": "Il tuo negozio non ha ancora pubblicato nessun post sul blog. Un blog può essere utilizzato per parlare del lancio di nuovi prodotti, dare suggerimenti o altre notizie che desideri condividere con i tuoi clienti. Dai un’occhiata al blog di ecommerce di Shopify per farti ispirare e per trovare idee e consigli relativi al tuo negozio e blog.",
      "blog_author": "Nome dell'autore",
      "no_content": "Attualmente questa sezione non contiene nessun contenuto. Aggiungi contenuto a questa sezione utilizzando la barra laterale."
    }
  },
  "layout": {
    "navigation": {
      "search": "Cerca",
      "expand": "espandi",
      "collapse": "comprimi",
      "menu": "Menu"
    },
    "cart": {
      "title": "Carrello",
      "items_count": {
        "one": "articolo",
        "other": "articoli"
      }
    },
    "customer": {
      "account": "Account",
      "log_out": "Esci",
      "log_in": "Accedi",
      "create_account": "Crea account"
    },
    "footer": {
      "social_platform": "{{ name }} su {{ platform }}"
    }
  },
  "products": {
    "product": {
      "regular_price": "Prezzo di listino",
      "sold_out": "Esaurito",
      "unavailable": "Non disponibile",
      "on_sale": "In Offerta",
      "sale_price": "Prezzo scontato",
      "quantity": "Quantità",
      "add_to_cart": "Aggiungi al carrello",
      "loader_label": "Inserimento del prodotto nel carrello",
      "back_to_collection": "Torna a {{ title }}",
      "vendor": "Venditore",
      "quantity_minimum_message": "La quantità deve essere 1 o più",
      "include_taxes": "Imposte incluse.",
      "shipping_policy_html": "<a href=\"{{ link }}\">Spedizione</a> calcolata al momento del pagamento.",
      "unit_price_label": "Prezzo unitario",
      "view_cart": "Visualizza carrello",
      "availability": "Disponibilità",
      "from_lowest_price_html": "da {{ lowest_price }}",
      "view_in_space": "Visualizza nel tuo spazio",
      "view_in_space_label": "Visualizzazione nel tuo spazio, carica l'elemento nella finestra di realtà aumentata"
    }
  },
  "gift_cards": {
    "issued": {
      "title_html": "Ecco il tuo {{ value }} buono regalo per {{ shop }}!",
      "subtext": "Il tuo buono regalo",
      "gift_card_code": "codice della carta regalo",
      "disabled": "Disabilitati",
      "expired": "Scaduto il {{ expiry }}",
      "active": "Scade il {{ expiry }}",
      "redeem_html": "Utilizza questo codice alla cassa per riscattare la tua carta regalo di {{ value }}",
      "shop_link": "Inizia a fare shopping",
      "print": "Stampa questo buono regalo",
      "remaining_html": "{{ balance }} rimasti",
      "add_to_apple_wallet": "Aggiungi a Apple Wallet",
      "qr_image_alt": "Codice QR: scansiona per riscattare la carta regalo"
    }
  },
  "store_availability": {
    "general": {
      "view_store_info": "Visualizza i dettagli del negozio",
      "check_other_stores": "Verifica la disponibilità in altri negozi",
      "pick_up_available": "Ritiro disponibile",
      "pick_up_currently_unavailable": "Ritiro attualmente non disponibile",
      "pick_up_available_at_html": "Ritiro disponibile presso <strong>{{ location_name }}</strong>",
      "pick_up_unavailable_at_html": "Ritiro presso <strong>{{ location_name }}</strong> attualmente non disponibile"
    }
  },
  "dynosim": {
    "auto": {
      "multiple_sessions_detected": "Rilevate sessioni multiple",
      "your_account_is_active_in_another_window": "Il tuo account è attivo in un'altra finestra o dispositivo. Chiudi l'altra sessione per continuare a usare AlphaX Tuning Sim.",
      "alphax_tuning_simulator": "Simulatore di Tuning AlphaX",
      "garage_tuning": "Garage (Tuning)",
      "dynamometer": "Dinamometro",
      "drag_strip": "Drag Strip",
      "leaderboards": "Classifiche",
      "login": "login",
      "import_tune": "IMPORTA MAPPA",
      "export_tune": "Esporta Mappa",
      "start_engine": "AVVIA MOTORE",
      "rpm": "RPM",
      "147": "14.7",
      "afr": "AFR",
      "status": "Stato:",
      "off": "OFF",
      "map": "MAP:",
      "101_kpa": "101 kPa",
      "boost": "Boost:",
      "00_psi": "0.0 psi",
      "config": "Config:",
      "twin_turbo": "TWIN TURBO",
      "tps": "TPS:",
      "0": "0%",
      "timing": "Anticipo:",
      "knk_retard": "Ritardo KNK:",
      "knock_count": "Conteggio Battiti:",
      "inj_pw_cyl_1": "Inj. PW (Cil 1):",
      "00_ms": "0.0 ms",
      "vvt_intake": "VVT Aspirazione:",
      "vvt_exhaust": "VVT Scarico:",
      "coolant_temp": "Temp. Liquido:",
      "_": "+ / - / *",
      "ethanol": "Etanolo:",
      "fuel_rail": "Rail Carburante:",
      "_psi": "-- PSI",
      "stft": "STFT:",
      "pump_load": "Carico Pompa:",
      "battery": "Batteria:",
      "125_v": "12.5 V",
      "max_pedal_tps": "TPS Max Pedale",
      "100": "100%",
      "throttle_hold": "Blocco Farfalla",
      "pedal": "PEDALE",
      "ecu_flags": "FLAG ECU:",
      "engine_limits": "Limiti Motore",
      "trigger": "Trigger",
      "adv_uo": "Solo per utenti avanzati!",
      "smart_alternator": "Alternatore Intelligente",
      "axis_wizard": "Wizard Assi",
      "ve_table": "Tabella VE",
      "target_afr_table": "Tabella AFR Target",
      "fuel_settings": "Impostazioni Carburante",
      "flex_fuel": "Flex Fuel",
      "closed_loop_fuel": "Carburante Closed Loop",
      "accel_enrichment": "Arricchimento Accel.",
      "ignition_advance": "Anticipo Accensione",
      "ignition_settings": "Impostazioni Accensione",
      "knock_control": "Controllo Battito",
      "vvt_intake_target": "Target VVT Aspirazione",
      "vvt_exhaust_target": "Target VVT Scarico",
      "vvt_vtec_settings": "Impostazioni VVT / VTEC",
      "idle": "Minimo",
      "cranking": "Avviamento",
      "upgrades_mods": "Upgrade & Mods",
      "nitrous_system": "Sistema Nitrous",
      "wastegate_duty_table": "Tabella Duty Wastegate",
      "cl_boost_target": "Target Boost Closed Loop",
      "launch_control": "Launch Control",
      "simulation_settings": "Impostazioni Simulazione",
      "simple": "SIMPLE",
      "adv": "ADV",
      "buy_advanced_mode": "Compra Modalità Avanzata!",
      "log_off": "LOG OFF",
      "selection_tools": "Strumenti di Selezione:",
      "interp_x_row": "Interp X (Riga)",
      "interp_y_col": "Interp Y (Colonna)",
      "interp_2d_area": "Interp 2D (Area)",
      "keys_hinterp_x_vinterp_y_iinterp_2d_gtlt": "Keys: H=Interp X · V=Interp Y · I=Interp 2D · &gt;/&lt;=±1 · +/-/*=math then Enter · Arrows=navigate · Ctrl+C/V=copy/paste · Ctrl+Z/Y=undo/redo",
      "ve_table_load_vs_rpm": "Tabella VE (Carico vs RPM)",
      "higher_numbers_more_fuel_adjust_to_hit_t": "Numeri più alti = più carburante. Regola per raggiungere l'AFR target.",
      "target_afr_table_load_vs_rpm": "Tabella AFR Target (Carico vs RPM)",
      "commanded_airfuel_ratio_core_part_of_the": "Rapporto Aria/Carburante comandato. Parte fondamentale dell'equazione Speed Density.",
      "fuel_injector_settings": "Impostazioni Carburante e Iniettori",
      "injector_size_ccmin": "Dimensione Iniettore (cc/min)",
      "injector_reference_pressure_kpa": "Pressione Riferimento Iniettore (kPa)",
      "dead_time_ms_by_v": "Tempo Morto (ms per V)",
      "c": "°C",
      "multiplier_at_each_iat_10_no_change_09_1": "Moltiplicatore a ogni IAT. 1.0 = nessun cambio, 0.9 = -10%, 1.1 = +10%.",
      "ect_fuel_enrichment_": "Arricchimento Carburante ECT (×)",
      "fuel_multiplier_on_cold_start_10_no_corr": "Moltiplicatore carburante all'avviamento a freddo. 1.0 = nessuna correzione a temp regime.",
      "fuel_octane": "Ottani Carburante",
      "87_aki_regular": "87 AKI (Regolare)",
      "91_aki_premium": "91 AKI (Premium)",
      "93_aki_premium": "93 AKI (Premium+)",
      "100_aki_race_gas": "100 AKI (Race Gas)",
      "104_aki_race_gas": "104 AKI (Race Gas)",
      "116_aki_methanolrace": "116+ AKI (Metanolo/Race)",
      "display_afr_as_lambda_3_decimals": "Mostra AFR come Lambda (3 decimali)",
      "enable_fuel_pressure_model": "Abilita Modello Pressione Carburante",
      "base_fuel_pressure_psi": "Pressione Carburante Base (PSI)",
      "fuel_system_type": "Tipo Sistema Carburante",
      "return_style_rising_rate": "Style con Ritorno (rateo crescente)",
      "returnless_fixed_pressure": "Senza Ritorno (pressione fissa)",
      "return_style_rail_rises_11_with_boost_in": "Style con ritorno: la pressione rail sale 1:1 con il boost. Senza ritorno: pressione rail fissa.",
      "apply_settings": "Applica Impostazioni",
      "ignition_timing_table_load_vs_rpm": "Tabella Anticipo (Carico vs RPM)",
      "degrees_before_top_dead_center_too_much_": "Gradi prima del Punto Morto Superiore. Troppo anticipo causa battito.",
      "flex_fuel_sensor_simulation": "Simulazione Sensore Flex Fuel",
      "moving_this_slider_simulates_adding_etha": "Muovere questo slider simula l'aggiunta di etanolo.",
      "enable_flex_fuel_tuning_populate_flex_ta": "Abilita Tuning Flex Fuel",
      "ethanol_content_": "Contenuto Etanolo (%)",
      "apply_content": "Applica Contenuto",
      "flex_fuel_ve_adder_": "Adder VE Flex Fuel (%)",
      "blend_curve_0_100_x_base_map_map_vs_rpm": "Curva Blend (0-100%) x Mappa Base (MAP vs RPM)",
      "flex_fuel_afr_offset": "Offset AFR Flex Fuel",
      "flex_fuel_timing_adder_deg": "Adder Anticipo Flex Fuel (deg)",
      "flex_fuel_boost_duty_adder_": "Adder Duty Boost Flex Fuel (%)",
      "blend_curve_0_100_x_base_map_tps_vs_rpm": "Curva Blend (0-100%) x Mappa Base (TPS vs RPM)",
      "closed_loop_fuel_stft": "Carburante Closed Loop (STFT)",
      "enable_closed_loop_correction": "Abilita Correzione Closed Loop",
      "deadband_": "Banda Morta (%)",
      "lambda_error_within_this_band_is_ignored": "L'errore Lambda in questa banda è ignorato.",
      "tps_lt_5_rpm_near_idle_target": "(TPS < 5%, RPM vicino target minimo)",
      "time_constant_s": "Costante di Tempo (s)",
      "gain_00833_s": "Gain: 0.0833 /s",
      "min_correction_": "Correzione Min (%)",
      "max_correction_": "Correzione Max (%)",
      "part_throttle_cruise": "(parzializzato / crociera)",
      "gain_01250_s": "Gain: 0.1250 /s",
      "tps_gt_90": "(TPS > 90%)",
      "gain_02000_s": "Gain: 0.2000 /s",
      "acceleration_enrichment": "Arricchimento in Accelerazione",
      "corrects_fueling_during_rapid_throttle_o": "Corregge la carburazione durante aperture rapide della farfalla.",
      "mode": "MODALITÀ:",
      "none_disabled": "Nessuna (Disabilitato)",
      "ms_adder": "Adder MS",
      "map_prediction": "Predizione MAP",
      "accel_time_s": "Tempo Accel. (s)",
      "hard_cutoff_duration_of_enrichment_event": "Hard cutoff duration of enrichment event",
      "decay_rate": "Rateo Decadimento",
      "ms_mode_mss_middot_map_mode_blends": "MS mode: ms/s &middot; MAP mode: blend/s",
      "ms_adder_dtps_s_vs_rpm_rarr_ms": "Adder MS (dTPS %/s vs RPM → ms)",
      "extra_injection_ms_on_tip_in_y_tps_rate_": "Iniezione extra ms su tip-in.",
      "map_prediction_tps_vs_rpm_rarr_kpa": "Predizione MAP (TPS % vs RPM → kPa)",
      "predicted_map_for_veafrtiming_lookups_du": "Predicted MAP for VE/AFR/timing lookups during tip-in. Y = TPS %, X = RPM.",
      "ignition_system_mode": "Modalità Sistema Accensione",
      "sets_coil_topology_recharge_time_and_mel": "Sets coil topology, recharge time, and melt behavior.",
      "distributor_single_coil": "Spinterogeno (Bobina Singola)",
      "wasted_spark_n2_coils": "Scintilla Persa (N/2 Bobine)",
      "fully_sequential_cop": "Sequenziale Completo / COP",
      "spark_plug_gap_inches": "Gap Candele (pollici)",
      "wider_gap_needs_more_dwell_to_fire_under": "Wider gap = needs more dwell to fire. Under boost, effective gap shrinks 0.005&quot; per 10 psi — tighter gaps recommended on boosted builds.",
      "degrees_of_retard_at_each_iat_0_no_retar": "Gradi di ritardo a ogni IAT. 0 = nessun ritardo.",
      "coil_dwell_time_ms_by_battery_v": "Tempo Carica Bobina (ms per Batteria V)",
      "coil_charge_time_low_voltage_during_cran": "Coil charge time. Low voltage during cranking may cause weak spark.",
      "knock_sensor_spectrogram": "Spettrogramma Sensore Battito",
      "pause": "PAUSA",
      "cyan_noise_level_nbspnbsp_red_dashed_thr": "Ciano = livello rumore | Rosso tratteggiato = soglia",
      "_25s": "-2.5s",
      "now": "Ora",
      "knock_threshold_db_vs_rpm": "Soglia Battito (dB vs RPM)",
      "noise_level_above_which_a_knock_event_tr": "Noise level above which a knock event triggers retard. At idle background noise is ~-26 dB; knock spikes to ~-2 dB.\n                                Set each cell just below the lowest knock spike at that RPM. Default -10 dB is a good starting point at lower RPM.\n                                At high RPM you may need to lower to -15 dB or below to avoid false positives.",
      "control_parameters": "Parametri di Controllo",
      "enable_knock_control": "Abilita Controllo Battito",
      "complete_knock_frequency_calibration_bel": "Complete Knock Frequency Calibration below to unlock.",
      "attack_degevent": "Attacco (deg/evento)",
      "degrees_removed_per_knock_detection_0510": "Degrees removed per knock detection. 0.5–10°",
      "max_retard_deg": "Ritardo Max (deg)",
      "maximum_accumulated_retard_120": "Maximum accumulated retard. 1–20°",
      "recovery_rate_degrev": "Rateo Recupero (deg/rev)",
      "degrees_recovered_per_engine_revolution_": "Degrees recovered per engine revolution. 0.1–2.0",
      "min_tps_to_engage_": "TPS Min per Ingaggiare (%)",
      "suppresses_retard_below_this_throttle_po": "Suppresses retard below this throttle position. Prevents false triggers on decel pops.",
      "min_map_to_engage_kpa": "MAP Min per Ingaggiare (kPa)",
      "suppresses_retard_below_this_manifold_pr": "Suppresses retard below this manifold pressure. 60 kPa ≈ light cruise.",
      "knock_control_frequency_calibration_mode": "Calibrazione Frequenza Controllo Battito",
      "enter_calibration_mode": "Entra in Calibrazione",
      "identify_the_engines_natural_knock_reson": "Identifica la risonanza naturale di battito del motore.",
      "formula_f_573_boremm_nbspnbsp_81_mm_bore": "Formula: f ≈ 573 ÷ bore_mm &nbsp;|&nbsp; 81 mm bore ≈ 7.07 kHz &nbsp;|&nbsp; 102 mm bore ≈ 5.61 kHz",
      "20k": "20k",
      "15k": "15k",
      "10k": "10k",
      "5k": "5k",
      "_5_seconds_ago": "← 5 seconds ago",
      "now_": "Now →",
      "center_freq_khz": "Freq. Centrale (kHz)",
      "khz": "kHz",
      "temp_timing_adder": "Adder Anticipo Temp.",
      "_for": "° for",
      "s": "s",
      "apply": "Applica",
      "confirm_calibration": "Conferma Calibrazione",
      "recalibrate": "Ricalibra",
      "nitrous_oxide_system": "Sistema Protossido d'Azoto",
      "upgrades_amp_mods": "Upgrade & Mods",
      "n2o_jet_size_thousandths_in": "Dimensione Getto N2O (millesimi di pollice)",
      "estimated_power": "Potenza Stimata",
      "_337_hp": "≈ 33.7 HP",
      "fuel_jet_size_thousandths_in": "Dimensione Getto Carburante (millesimi di pollice)",
      "wet_shot_fuel_solenoid_handles_base_enri": "Wet shot: fuel solenoid handles base enrichment. ECU VE comp adds on top.",
      "activation_mode": "Modalità Attivazione",
      "button_switch": "Bottone / Interruttore",
      "ecu_control": "Controllo ECU",
      "ecu_control_parameters": "Parametri Controllo ECU",
      "min_tps_": "TPS Min (%)",
      "min_rpm": "RPM Min",
      "max_rpm": "RPM Max",
      "max_map_kpa": "MAP Max (kPa)",
      "afr_safety_cut_lean": "Taglio Sicurezza AFR (magro)",
      "fuel_ve_comp_": "Comp. VE Carburante (%)",
      "extra_fuel_when_n2o_is_active_dry_primar": "Extra fuel when N2O is active. Dry = primary comp. Wet = supplement on top of fuel solenoid.",
      "timing_retard_": "Ritardo Anticipo (°)",
      "degrees_pulled_from_commanded_timing_whe": "Degrees pulled from commanded timing when N2O is active.",
      "apply_nitrous_settings": "Applica Impostazioni Nitrous",
      "vvt_intake_advance_target_load_vs_rpm": "Target Anticipo VVT Aspirazione (Carico vs RPM)",
      "positive_degrees_of_intake_cam_advance_i": "Positive degrees of intake cam advance. Interpolates absolute \"In_X\" engine maps.",
      "vvt_exhaust_retard_target_load_vs_rpm": "Target Ritardo VVT Scarico (Carico vs RPM)",
      "negative_degrees_of_exhaust_cam_retard_i": "Negative degrees of exhaust cam retard. Interpolates absolute \"Ex_X\" engine maps.",
      "variable_valve_lift_vvl_vtec": "Alzata Valvole Variabile (VVL / VTEC)",
      "vvl_high_cam_switch_rpm": "Switch VVL / Camma Alta (RPM)",
      "vvl_high_cam_min_tps_": "TPS Min Camma Alta VVL (%)",
      "vvl_fuel_adder_ve_": "Adder Carburante VVL (VE %)",
      "vvl_timing_adder_": "Adder Anticipo VVL (°)",
      "continuous_vvt_phase_angles_are_controll": "Continuous VVT phase angles are controlled via the 9x9 tables.",
      "closed_loop_pid_control": "Controllo PID Closed Loop",
      "enable_closed_loop_pid_control": "Abilita Controllo PID Closed Loop",
      "proportional_kp": "Proporzionale (Kp)",
      "integral_ki": "Integrale (Ki)",
      "derivative_kd": "Derivativo (Kd)",
      "higher_kp_faster_response_ki_eliminates_": "Higher Kp = faster response. Ki eliminates steady-state error. Kd damps overshoot. Live display shows actual° / target° when enabled.",
      "wastegate_duty_table_tps_vs_rpm": "Tabella Duty Wastegate (TPS vs RPM)",
      "commanded_wastegate_solenoid_duty_cycle_": "Commanded wastegate solenoid duty cycle (0–100%). Higher duty = more boost. Requires a turbocharger mod installed. In Closed-Loop Boost mode this table acts as the feed-forward base; the PID trims on top.",
      "cl_boost_target_table_tps_vs_rpm": "Tabella Target Boost Closed Loop (TPS vs RPM)",
      "target_boost_pressure_in_psi_used_when_c": "Target boost pressure in PSI. Used when Closed-Loop Boost is enabled in Mod Settings. 0 = match wastegate spring pressure. The WG Duty table is the feed-forward base; the PID adjusts duty to hit this target.",
      "rev_limit_rpm": "Limitatore Giri (RPM)",
      "rev_limit_hysteresis_rpm": "Isteresi Limitatore (RPM)",
      "fuel_cut": "Taglio Carburante",
      "spark_cut": "Taglio Scintilla",
      "enable_decel_fuel_cut": "Abilita Taglio Carburante in Decel.",
      "cut_delay_sec": "Ritardo Taglio (Sec)",
      "boost_protection": "Protezione Boost",
      "boost_cut_psi": "Taglio Boost (psi)",
      "hysteresis_psi": "Isteresi (psi)",
      "trigger_calibration": "Calibrazione Trigger",
      "timing_light_mode": "Modalità Pistola Stroboscopica",
      "simulates_a_timing_light_check_engine_st": "Simulates a timing light check. Engine start is disabled while active.",
      "must_match_engine_base_offset_affects_ti": "must match engine base offset — affects timing at all times",
      "fixed_timing_ecu_commanded_045_btdc": "Fixed Timing — ECU commanded (0–45° BTDC)",
      "enable_smart_alternator": "Abilita Alternatore Intelligente",
      "alt_pressure_rises_05_v_per_1000_rpm_pid": "Alt pressure rises +0.5 V per 1000 RPM. PID controls duty to hold target voltage.",
      "p_gain": "Guadagno P",
      "i_gain": "Guadagno I",
      "d_gain": "Guadagno D",
      "alternator_duty": "Duty Alternatore:",
      "na": "N/A",
      "axis_setup_wizard": "Wizard Setup Assi",
      "sets_the_16_point_rpm_and_map_load_axes_": "Sets the 16-point RPM and MAP (load) axes for the VE, AFR, and Timing tables. WG Duty table columns (RPM) also update. The WG Duty row axis (TPS) is unaffected.",
      "base_rpm": "RPM Base",
      "base_kpa_min_load": "kPa Base (carico min)",
      "max_kpa": "kPa Max",
      "apply_axis_wizard": "Applica Wizard Assi",
      "reset_to_default": "Reset a Default",
      "note_existing_tune_values_are_interpolat": "Note: existing tune values are interpolated/extrapolated onto the new axes. Values beyond your current range are linearly extrapolated from the edge trend.",
      "idle_settings": "Impostazioni Minimo",
      "maximum_idle_tps": "TPS Massimo Minimo",
      "actual_throttle_when_duty_curve_reads_10": "Actual throttle % when duty curve reads 100%.",
      "idle_control_rpm_upper_limit": "Limite Superiore RPM Controllo Minimo",
      "idle_control_disengages_above_target_rpm": "Idle control disengages above Target RPM + this value.",
      "target_idle_rpm_vs_coolant_temp": "Target RPM Minimo vs Temp. Liquido",
      "idle_rpm_target_by_coolant_temperature_r": "Idle RPM target by coolant temperature. Runs higher when cold.",
      "idle_duty_vs_coolant_temp_": "Duty Minimo vs Temp. Liquido (%)",
      "_of_maximum_idle_tps_to_command_at_each_": "% of Maximum Idle TPS% to command at each coolant temperature.",
      "closed_loop_idle_ignition": "Accensione Minimo Closed Loop",
      "uses_ignition_timing_to_maintain_target_": "Uses ignition timing to maintain target idle RPM for faster corrections.",
      "p": "P",
      "i": "I",
      "d": "D",
      "cranking_starting": "Avviamento / Partenza",
      "base_ve": "VE Base",
      "max_crank_rpm": "RPM Massimo Avviamento",
      "decay_s": "Decadimento (s)",
      "crank_time_s": "Tempo Avviamento (s)",
      "cranking_idle_air_duty_vs_coolant_temp_": "Duty Aria Minimo Avviamento vs Temp. Liquido (%)",
      "throttle_position_air_during_cranking_hi": "Throttle position (air) during cranking. Higher when cold to overcome friction.",
      "post_crank_enrichment_vs_coolant_temp_ve": "Arricchimento Post-Avviamento vs Temp. Liquido (×VE)",
      "fuel_multiplier_applied_immediately_afte": "Fuel multiplier applied immediately after cranking ends. 1.0 = no enrichment.",
      "post_crank_decay_cycles": "Cicli Decadimento Post-Avviamento",
      "engine_cycles_720_each_for_enrichment_to": "Engine cycles (720° each) for enrichment to decay from curve value to 1.0×.",
      "vehicle_upgrades": "Upgrade Veicolo",
      "export_mod_list": "ESPORTA LISTA MOD",
      "import_mod_list": "IMPORTA LISTA MOD",
      "mod_collection": "Collezione Mod",
      "tuner_warning_extreme_mods_like_heavy_ca": "TUNER WARNING: Extreme mods like heavy cams will increase idle vacuum penalty (raises base MAP), which can stall your engine! You will need to tune your low-RPM fuel/timing and raise target idle RPM to compensate.",
      "launch_control_two_step": "Launch Control / Two-Step",
      "enable_launch_control": "Abilita Launch Control",
      "launch_rpm": "RPM Lancio",
      "hysteresis_rpm": "Isteresi (RPM)",
      "window_size_rpm": "Dimensione Finestra (RPM)",
      "cut_type": "Tipo Taglio",
      "ignition_cut": "Taglio Accensione",
      "both_hard_cut": "Entrambi (Taglio Netto)",
      "window_start_timing_deg": "Anticipo Inizio Finestra (deg)",
      "limit_timing_deg_absolute": "Limite Anticipo (deg assoluto)",
      "fuel_adder_afr_": "Adder Carburante (AFR %)",
      "activate_two_step_mode_switch": "Attiva Switch Modalità Two-Step",
      "test_your_launch_settings_in_the_garage_": "Test your launch settings in the garage. When active, the engine will limit to Launch RPM at full throttle even in Neutral.",
      "ambient_conditions_used_as_the_baseline_": "Ambient conditions used as the baseline for all simulations — dyno pulls, drag runs, and the garage physics loop.",
      "unit_system": "Sistema Unità",
      "affects_all_displayed_temperatures_press": "Affects all displayed temperatures, pressures, and speed. AFR/Lambda can be toggled separately by clicking the gauge.",
      "pressure_display_mode": "Modalità Visualizzazione Pressione",
      "absolute": "Assoluta",
      "gauge": "Relativa",
      "switches_pressure_on_y_axes_and_gauges": "Passa la pressione sugli assi Y e i misuratori tra pressione assoluta e relativa. I calcoli interni usano sempre kPa assoluto.",
      "ambient_temperature_f": "Temperatura Ambiente (°F)",
      "ambient_temperature_c": "Temperatura Ambiente (°C)",
      "sets_base_iat_for_the_physics_loop": "Sets base IAT for the physics loop.",
      "barometric_pressure_kpa": "Pressione Barometrica (kPa)",
      "affects_map_ceiling_and_airmass_scaling_": "Affects MAP ceiling and airmass scaling (altitude).",
      "relative_humidity_": "Umidità Relativa (%)",
      "used_for_dyno_correction_factor_sae_std": "Used for dyno correction factor (SAE / STD).",
      "coolant_temperature_simulation": "Simulazione Temp. Liquido",
      "enable_ect_simulation": "Abilita Simulazione ECT",
      "when_enabled_engine_starts_cold_at_ambie": "Se abilitato, il motore parte freddo a temperatura ambiente e si riscalda fino a 90 °C. Disabilitato = ECT bloccato a 90 °C.",
      "o2_sensor_simulation": "Simulazione Sensore O2",
      "enable_o2_transport_delay_amp_combustion": "Abilita Ritardo Trasporto O2 e Rumore di Combustione",
      "adds_exhaust_transport_delay_to_afr_disp": "Aggiunge il ritardo di trasporto allo scarico alla lettura AFR (300ms al minimo, 0ms a 3500 RPM) e varianza di combustione ±3% alla fisica a bassi regimi.",
      "starter_mode": "Modalità Avviatore",
      "hold_to_engage_hold_the_button_while_the": "Hold to Engage: hold the button while the starter cranks; release after engine fires.",
      "knock_indicator": "Indicatore Battito",
      "show_knock_event_indicator_overlay": "Mostra overlay indicatore battito",
      "floating_counter_shown_in_all_views_when": "Contatore flottante mostrato in tutte le viste quando il motore batte in testa. In Modalità Avanzata usa la scheda Controllo Battito.",
      "transmission_selection": "Selezione Trasmissione",
      "export": "ESPORTA",
      "custom_ratios": "Rapporti Personalizzati",
      "final_drive_ratio": "RAPPORTO FINALE",
      "gear_1": "MARCIA 1",
      "gear_2": "MARCIA 2",
      "gear_3": "MARCIA 3",
      "gear_4": "MARCIA 4",
      "gear_5": "MARCIA 5",
      "gear_6": "MARCIA 6",
      "gear_7": "MARCIA 7",
      "gear_8": "MARCIA 8",
      "gear_9": "MARCIA 9",
      "gear_10": "MARCIA 10",
      "set_ratio_to_0_to_disable_a_gear": "Set ratio to 0 to disable a gear.",
      "apply_simulation_settings": "Applica Impostazioni Simulazione",
      "virtual_dynamometer": "Dinamometro Virtuale",
      "loads_the_engine_dynamically_to_perform_": "Loads the engine dynamically to perform a real-time full-throttle sweep from start RPM to redline.",
      "auto_log_off": "AUTO-LOG OFF",
      "set_as_reference": "IMPOSTA COME RIFERIMENTO",
      "hold_n2o": "TIENI — N2O",
      "smoothing": "SMOOTHING:",
      "0_raw": "0 (Grezzo)",
      "5_max": "5 (Max)",
      "correction": "CORREZIONE:",
      "none": "Nessuna",
      "sae": "SAE",
      "std": "STD",
      "load_dyno": "Carica Dinamometro",
      "rpm_lock": "Blocco RPM",
      "dynojet": "Dynojet",
      "rpms": "RPM/S:",
      "target_rpm": "TARGET RPM:",
      "afr_guideline": "LINEA GUIDA AFR:",
      "start_rpm": "START RPM:",
      "ambient_conditions_advanced_simulation_s": "Ambient conditions: Advanced → Simulation Settings",
      "leaderboard_display_name": "Nome Visualizzato Classifica",
      "submit_to_leaderboard": "Invia alla Classifica",
      "clutch_0": "FRIZIONE: 0%",
      "run": "RUN",
      "launch": "LANCIO",
      "60ft": "60ft",
      "330ft": "330ft",
      "18_mile": "1/8 Mile",
      "1000ft": "1000ft",
      "14_mile": "1/4 Mile",
      "reaction_time": "Tempo Reazione",
      "9872_check_run_category": "&#9872; Check Run Category",
      "sim_config": "Config Sim",
      "weight_lbs": "Peso (lbs)",
      "shift_rpm": "RPM Cambiata",
      "shift_delay_s": "Ritardo Cambiata (s)",
      "tires": "Pneumatici",
      "economy": "Economy",
      "street": "Street",
      "summer": "Summer",
      "drag_radials": "Drag Radials",
      "drag_slicks": "Drag Slicks",
      "clutch_slip_s": "Slittamento Frizione (s)",
      "lb_class": "Classe LB",
      "run_controls": "Controlli Run",
      "start_1x": "START (1x)",
      "ff_3x": "FF (3x)",
      "instant": "ISTANTANEO",
      "shift_up": "CAMBIA SU",
      "abort": "ABORTISCI",
      "n2o": "N2O",
      "manual_mode": "Modalità Manuale",
      "no_shift_on_slip": "No Cambiata se Slitta",
      "auto_log": "Auto-Log",
      "hold_cspace_on_line_release_c_to_launch_": "Hold C+SPACE on line → release C to launch &nbsp;|&nbsp; SPACE=throttle &nbsp;C=clutch &nbsp;S=shift↑ &nbsp;X=shift↓",
      "requirement": "Requisito:",
      "logged_in": "loggato",
      "advanced_mode": "Modalità Avanzata",
      "default_vehicle_weight": "Peso Veicolo Default",
      "01s_shift_delay": "0.1s Ritardo Cambiata",
      "engine": "Motore",
      "category": "Categoria",
      "stock_economy": "Stock — Economy",
      "stock_street": "Stock — Street",
      "stock_summer": "Stock — Summer",
      "stock_drag_radials": "Stock — Drag Radials",
      "stock_drag_slicks": "Stock — Drag Slicks",
      "mod_na_economy": "Mod N/A — Economy",
      "mod_na_street": "Mod N/A — Street",
      "mod_na_summer": "Mod N/A — Summer",
      "mod_na_drag_radials": "Mod N/A — Drag Radials",
      "mod_na_drag_slicks": "Mod N/A — Drag Slicks",
      "power_adder_economy": "Power Adder — Economy",
      "power_adder_street": "Power Adder — Street",
      "power_adder_summer": "Power Adder — Summer",
      "power_adder_drag_radials": "Power Adder — Drag Radials",
      "power_adder_drag_slicks": "Power Adder — Drag Slicks",
      "super_pa_economy": "Super PA — Economy",
      "super_pa_street": "Super PA — Street",
      "super_pa_summer": "Super PA — Summer",
      "super_pa_drag_radials": "Super PA — Drag Radials",
      "super_pa_drag_slicks": "Super PA — Drag Slicks",
      "search": "Cerca",
      "knock_detected": "Battito Rilevato",
      "0_events": "0 eventi",
      "v001": "v0.0.1",
      "1_2": "1 / 2",
      "times": "×",
      "simple_mode_vs_advanced_mode": "Modalità Semplice vs Avanzata",
      "free": "(Gratis)",
      "purchased": "(Acquistato)",
      "click_here_to_get_advanced_mode_": "Clicca qui per Modalità Avanzata →",
      "extra_engines_amp_mods": "Motori & Mod Extra",
      "click_here_to_browse_engines_": "Clicca qui per i Motori →",
      "click_here_to_browse_mods_": "Clicca qui per le Mod →",
      "128274_log_in_to_access_your_purchases": "&#128274; Log In to Access Your Purchases",
      "alphax_account": "Account AlphaX",
      "alphaxprcom": "alphaxpr.com",
      "controls": "Controlli",
      "space": "Spazio",
      "click_drag": "Click / Trascina",
      "click_cell": "Click cella",
      "ctrlz_y": "Ctrl+Z / Y",
      "table_keyboard_shortcuts": "Shortcut Tastiera Tabella",
      "arrows": "Frecce",
      "gt_lt": "&gt; / &lt;",
      "h": "H",
      "v": "V",
      "ctrlc_v": "Ctrl+C / V",
      "datalogging": "Datalogging",
      "basic_tuning_tips": "Consigli Basic Tuning",
      "ignition_timing": "Anticipo Accensione",
      "target_afr": "AFR Target",
      "map_axis": "Asse MAP",
      "_back": "← Indietro",
      "controls_": "Controlli →",
      "got_it_": "Capito! ✓",
      "run_category_check": "Run Category Check",
      "close": "Chiudi",
      "save_your_tune": "Salva Mappa",
      "you_have_unsaved_tuning_changes": "Hai modifiche non salvate.",
      "export_your_tune_before_closing_so_you_c": "Export your tune before closing so you can reload it later.",
      "dismiss": "Ignora",
      "keep_adjusting": "Continua a Regolare",
      "timing_is_correct_": "L'Anticipo è Corretto ✓",
      "commanded_wastegate_solenoid_duty_cycle": "Commanded wastegate solenoid duty cycle (0–100%). Higher duty = more boost. Requires a turbocharger mod installed. In Closed-Loop Boost mode this table acts as the feed-forward base; the PID trims on top.",
      "integrates_the_lambda_error_between_actu": "Integrates the lambda error between actual and target AFR each frame and applies a Short-Term Fuel Trim multiplier to correct fueling. Uses your Target AFR table as the setpoint. The integrator gain is",
      "dry_shot_switch_mode_no_ecu_compensation": "Dry shot, switch mode: no ECU compensation is applied. Bake your fuel and timing corrections directly into your VE and timing maps.",
      "sets_the_16_point_rpm_and_map_load_axes": "Sets the 16-point RPM and MAP (load) axes for the VE, AFR, and Timing tables. WG Duty table columns (RPM) also update. The WG Duty row axis (TPS) is unaffected.",
      "keys_hinterp_x_vinterp_y_iinterp_2d_1_ma": "Keys: H=Interp X · V=Interp Y · I=Interp 2D · &gt;/&lt;=±1 · +/-/*=math then Enter · Arrows=navigate · Ctrl+C/V=copy/paste · Ctrl+Z/Y=undo/redo",
      "higher_kp_faster_response_ki_eliminates": "Higher Kp = faster response. Ki eliminates steady-state error. Kd damps overshoot. Live display shows actual° / target° when enabled.",
      "formula_f_573_boremm_81_mm_bore_707_khz": "Formula: f ≈ 573 ÷ bore_mm &nbsp;|&nbsp; 81 mm bore ≈ 7.07 kHz &nbsp;|&nbsp; 102 mm bore ≈ 5.61 kHz",
      "test_your_launch_settings_in_the_garage": "Test your launch settings in the garage. When active, the engine will limit to Launch RPM at full throttle even in Neutral.",
      "hold_cspace_on_line_release_c_to_launch": "Hold C+SPACE on line → release C to launch &nbsp;|&nbsp; SPACE=throttle &nbsp;C=clutch &nbsp;S=shift↑ &nbsp;X=shift↓",
      "ambient_conditions_used_as_the_baseline": "Ambient conditions used as the baseline for all simulations — dyno pulls, drag runs, and the garage physics loop.",
      "mods_include_turbochargers_camshafts_coo": "Mods include turbochargers, camshafts, cooling upgrades, and more — each with real physics effects.",
      "loads_the_engine_dynamically_to_perform": "Loads the engine dynamically to perform a real-time full-throttle sweep from start RPM to redline.",
      "each_engine_has_its_own_power_curve_knoc": "Each engine has its own power curve, knock limits, compression ratio, and tuning maps.",
      "trigger_angle_offset_ecu_360360": "Trigger Angle Offset — ECU (-360–360°)",
      "55_sub_axes_derived_from_the_main_rpm_an": "5×5 sub-axes derived from the main RPM and MAP axes. Scales with the Axis Wizard.",
      "advanced_mode_activates_automatically_wh": "Advanced Mode activates automatically when your purchase is detected at login.",
      "trigger_offset_matches_engine_base_the_t": "Trigger offset matches engine base — the timing mark is perfectly aligned.",
      "inj_mismatch": "Injector size mismatch — check Fuel Settings matches installed injectors",
      "uses_ignition_timing_to_maintain_target": "Uses ignition timing to maintain target idle RPM for faster corrections.",
      "on_the_store_for_the_simulator_to_detect": "on the store for the simulator to detect your purchases and unlock them.",
      "engine_load_in_kpa_higher_more_load_mor": "— engine load in kPa. Higher = more load = more fuel &amp; timing needed",
      "if_you_purchased_something_and_dont_see": "If you purchased something and don't see it, log in to your account on",
      "cyan_noise_level_red_dashed_threshold_at": "Cyan = noise level &nbsp;|&nbsp; Red dashed = threshold at current RPM",
      "torque_bonus_0_at_145_v_3_at_125_v_reduc": "Torque bonus: 0% at 14.5 V → +3% at 12.5 V (reduced alternator drag).",
      "extra_injection_ms_on_tip_in_y_tps_rate": "Extra injection ms on tip-in. Y = TPS rate of change (%/s), X = RPM.",
      "your_purchased_engines_mods_and_advanced": "Your purchased engines, mods, and Advanced Mode are tied to your",
      "logs_include_rpm_map_afr_timing_ve_torqu": "Logs include RPM, MAP, AFR, timing, VE, torque, boost, and more",
      "advance_for_power_but_watch_for_knock_t": "— advance for power, but watch for knock. Typical MBT is 25–35°",
      "degrees_before_top_dead_center_too_much": "Degrees Before Top Dead Center. Too much advance causes knock.",
      "of_maximum_idle_tps_to_command_at_each": "% of Maximum Idle TPS% to command at each coolant temperature.",
      "richer_11121_under_boostwot_stoich_1471": "— richer (11–12:1) under boost/WOT, stoich (14.7:1) at cruise",
      "controls_fuel_delivery_aim_for_1471_afr": "— controls fuel delivery. Aim for ~14.7:1 AFR at cruise",
      "to_submit_runs_must_use": "to submit. \n                            Runs must use",
      "flood_hint": "Hold throttle to floor while cranking to clear flood",
      "affects_map_ceiling_and_airmass_scaling": "Affects MAP ceiling and airmass scaling (altitude).",
      "select_an_engine_and_category_to_view_le": "Select an engine and category to view leaderboards.",
      "degrees_recovered_per_engine_revolution": "Degrees recovered per engine revolution. 0.1–2.0",
      "enable_o2_transport_delay_combustion_noi": "Enable O2 Transport Delay &amp; Combustion Noise",
      "focus_math_input_type_value_enter_to_ap": "— Focus math input → type value → Enter to apply",
      "start_dyno_pull": "START DYNO PULL",
      "drag_strip_leaderboards": "Drag Strip Leaderboards",
      "copy_paste_selection_as_spreadsheet_dat": "— Copy / paste selection as spreadsheet data",
      "to_start_recording_stops_and_exports_a_c": "to start recording — stops and exports a CSV",
      "10003_ve_timing_target_afr_tables": "&#10003; VE, Timing &amp; Target AFR tables",
      "10003_flex_fuel_tables_e85_physics": "&#10003; Flex Fuel tables &amp; E85 physics",
      "interpolate_horizontally_across_selecti": "— Interpolate horizontally across selection",
      "cranking_idle_air_duty_vs_coolant_temp": "Cranking Idle Air Duty vs Coolant Temp (%)",
      "interpolate_vertically_across_selection": "— Interpolate vertically across selection",
      "available_in_garage_dyno_and_drag_modes": "Available in Garage, Dyno, and Drag modes",
      "ms_mode_mss_map_mode_blends": "MS mode: ms/s &middot; MAP mode: blend/s",
      "map_prediction_tps_vs_rpm_kpa": "MAP Prediction (TPS % vs RPM &rarr; kPa)",
      "10003_engine_damage_failure_rng": "&#10003; Engine damage &amp; failure RNG",
      "timing_is_correct": "Timing is Correct ✓",
      "imperial_f_psi_mph": "Imperial (°F &middot; PSI &middot; MPH)",
      "move_selection_hold_shift_to_extend": "— Move selection (hold Shift to extend)",
      "interpolate_2d_entire_selected_area": "— Interpolate 2D (entire selected area)",
      "select_a_dry_or_wet_shot_system_under": "Select a Dry or Wet Shot System under",
      "10003_launch_control_two_step": "&#10003; Launch control &amp; two-step",
      "add_subtract_1_from_selected_cells": "— Add / subtract 1 from selected cells",
      "target_voltage_v_rpm_vs_map_kpa": "Target Voltage (V) — RPM vs MAP (kPa)",
      "to_get_them": "to get them!",
      "metric_c_kpa_kph": "Metric (°C &middot; kPa &middot; KPH)",
      "10003_knock_detection_retard": "&#10003; Knock detection &amp; retard",
      "ms_adder_dtps_s_vs_rpm_ms": "MS Adder (dTPS %/s vs RPM &rarr; ms)",
      "to_qualify": "to qualify.",
      "10003_everything_in_simple_plus": "&#10003; Everything in Simple, plus:",
      "10003_accel_enrichment_ms_map": "&#10003; Accel enrichment (ms / MAP)",
      "tps_5_rpm_near_idle_target": "(TPS &lt; 5%, RPM near idle target)",
      "10003_dyno_drag_simulation": "&#10003; Dyno &amp; Drag simulation",
      "10003_coil_dwell_misfire_physics": "&#10003; Coil dwell misfire physics",
      "10003_vvt_vvl_cam_control": "&#10003; VVT &amp; VVL cam control",
      "10003_closed_loop_boost_control": "&#10003; Closed-loop boost control",
      "calibrated_center_frequency": "✓ Calibrated — center frequency:",
      "need_some_mods_head_over_to_the": "Need some mods? Head over to the",
      "10003_datalogging_csv_export": "&#10003; Datalogging (CSV export)",
      "10003_o2_sensor_delay_modeling": "&#10003; O2 sensor delay modeling",
      "10003_drag_racing_leaderboards": "&#10003; Drag racing leaderboards",
      "click_here_to_get_advanced_mode": "Click Here to get Advanced Mode →",
      "dont_show_again": "Don't show again",
      "map_load_axis_16_points_kpa": "MAP / Load Axis (16 points, kPa)",
      "flex_fuel_boost_duty_adder": "Flex Fuel Boost Duty Adder (%)",
      "10003_basic_closed_loop_afr": "&#10003; Basic closed-loop AFR",
      "click_here_to_browse_engines": "Click Here to browse Engines →",
      "idle_duty_vs_coolant_temp": "Idle Duty vs Coolant Temp (%)",
      "10003_tune_import_export": "&#10003; Tune import / export",
      "10003_smart_alternator_pid": "&#10003; Smart alternator PID",
      "no_nitrous_system_installed": "No nitrous system installed.",
      "10003_fuel_pressure_model": "&#10003; Fuel pressure model",
      "click_here_to_browse_mods": "Click Here to browse Mods →",
      "edit_a_tuning_table_value": "— Edit a tuning table value",
      "iat_timing_retard_by_iat": "IAT Timing Retard (by IAT",
      "vvl_high_cam_min_tps": "VVL / High Cam Min TPS (%)",
      "10003_idle_ignition_pid": "&#10003; Idle ignition PID",
      "extra_engines_mods": "Extra Engines &amp; Mods",
      "then_reload_this_page": ", then reload this page.",
      "hold_to_rev_the_engine": "— Hold to rev the engine",
      "ect_fuel_enrichment": "ECT Fuel Enrichment (×)",
      "10003_decel_fuel_cut": "&#10003; Decel fuel cut",
      "flex_fuel_ve_adder": "Flex Fuel VE Adder (%)",
      "iat_ve_comp_by_iat": "IAT VE Comp% (by IAT",
      "min_tps_to_engage": "Min TPS to Engage (%)",
      "vvl_fuel_adder_ve": "VVL Fuel Adder (VE %)",
      "voltage_regulator_pid": "Voltage Regulator PID",
      "relative_humidity": "Relative Humidity (%)",
      "modified_violations": "Modified+ violations:",
      "vvl_timing_adder": "VVL Timing Adder (°)",
      "rpm_axis_16_points": "RPM Axis (16 points)",
      "active_session_id": "Active Session ID:",
      "ethanol_content": "Ethanol Content (%)",
      "min_correction": "Min Correction (%)",
      "max_correction": "Max Correction (%)",
      "fuel_adder_afr": "Fuel Adder (AFR %)",
      "fuel_ve_comp": "Fuel VE Comp. (%)",
      "timing_retard": "Timing Retard (°)",
      "9888_red_light": "&#9888; RED LIGHT",
      "and_a_minimum_of": "and a minimum of",
      "timing_locked_in": "Timing Locked In!",
      "1_timeconstant": "1 / timeConstant",
      "throttle_pedal": "— Throttle pedal",
      "5_seconds_ago": "← 5 seconds ago",
      "live_telemetry": "LIVE TELEMETRY",
      "tps_90": "(TPS &gt; 90%)",
      "hold_to_engage": "Hold to Engage",
      "peak_boost": "PEAK BOOST: --",
      "ready_to_stage": "READY TO STAGE",
      "running_mode": "Running Mode",
      "push_to_start": "Push to Start",
      "undo_redo": "— Undo / Redo",
      "to_run_stock": "To run Stock:",
      "not_you": "! Not you? (",
      "firing_order": "FIRING ORDER",
      "deadband": "Deadband (%)",
      "you_must_be": "You must be",
      "simple_mode": "Simple Mode",
      "distributor": "DISTRIBUTOR",
      "n2o_active": "N2O: ACTIVE",
      "fuel_air": "Carburante & Aria",
      "vvt_cams": "VVT & Camme",
      "min_tps": "Min TPS (%)",
      "peak_hp": "PEAK HP: --",
      "peak_tq": "PEAK TQ: --",
      "clutch_slip": "CLUTCH SLIP",
      "clutch_fail": "CLUTCH FAIL",
      "vvl_vtec": "VVL / VTEC",
      "idle_mode": "Idle Mode",
      "ref_hp": "REF HP: --",
      "ref_tq": "REF TQ: --",
      "and_using": "and using",
      "decel_cut": "DECEL CUT",
      "ignition": "Accensione",
      "advanced": "Avanzato",
      "wot_mode": "WOT Mode",
      "337_hp": "≈ 33.7 HP",
      "got_it": "Capito! ✓",
      "idle_pid": "IDLE PID",
      "timeslip": "TIMESLIP",
      "psi": "-- PSI",
      "setup": "Configurazione",
      "player": "Player",
      "click": "Click",
      "back": "← Indietro",
      "25s": "-2.5s",
      "for": "° for",
      "speed": "VELOCITÀ",
      "accel": "ACCEL",
      "slip": "SLIP!",
      "time": "TEMPO",
      "gear": "MARCIA",
      "mods": "Mods",
      "tdc": "PMS",
      "mph": "MPH",
      "mod_intake": "Aspirazione",
      "mod_intake_manifold": "Collettore di Aspirazione",
      "mod_exhaust_manifold": "Collettore di Scarico",
      "mod_exhaust": "Scarico",
      "mod_port_and_polish": "Lavorazione Condotti",
      "mod_turbocharger": "Turbocompressore",
      "mod_supercharger": "Sovralimentatore",
      "mod_camshaft": "Albero a Camme",
      "mod_pistons": "Pistoni",
      "mod_rods": "Bielle",
      "mod_clutch": "Frizione",
      "mod_intercooler": "Intercooler",
      "mod_fuel_pump": "Pompa Carburante",
      "mod_fuel_injector": "Iniettore Carburante",
      "stock_none": "Originale / Nessuno",
      "dry_shot_system": "Sistema Dry Shot",
      "wet_shot_system": "Sistema Wet Shot",
      "buy_nitrous_kit": "Compra Kit Nitro!",
      "mod_settings": "Impostazioni Mod",
      "wastegate_spring_psi": "Molla Wastegate (psi)",
      "wastegate_spring_kpa": "Molla Wastegate (kPa)",
      "map_axes_scale_help": "Gli assi MAP scalano a 2× la pressione della molla.",
      "closed_loop_boost": "Boost Closed-Loop",
      "pulley_ratio": "Rapporto Puleggia (SC/Mot)",
      "bypass_threshold": "Soglia Bypass (%)",
      "max_sc_rpm": "RPM Max SC:",
      "twin_turbo_setup": "Setup Twin Turbo",
      "twin_turbo_help": "(×1.9 flusso d'aria, ~½× velocità di spool)",
      "custom_transmission": "Trasmissione Personalizzata",
      "applied": "Applied!",
      "stop_engine": "STOP ENGINE",
      "flooded": "FLOODED",
      "no_start_trigger": "NO START: TRIGGER ANGLE",
      "no_start_lean": "NO START: LEAN",
      "stalled": "STALLED",
      "stalled_rpm": "STALLED: RPM dropped below cranking speed.",
      "stalled_battery": "STALLED: Battery voltage critically low (8 V).",
      "submitting": "Submitting...",
      "submitted": "Submitted!",
      "error_retry": "Error (Retry)"
    }
  }
};